<template>
  <div class="modal modal-overlay" @click.self="$emit('close')">
    <div id="manual_control">

      <!------------------------------------------------------------------
      <-- 空調自動制御(手動) -設定-
      <------------------------------------------------------------------>
      <div class="manual_control_container" v-if="this.reserved == false">
        <h2>空調自動制御 -設定-</h2>
        <div class="form">
          <label style="color:red;">15分～30分まで空調機の制御を行います。</label>
          <ul>
            <li>
              <div>
                <label style="width:150px;">
                  <input
                    type="radio"
                    class="radio"
                    id="caution_control"
                    value="2"
                    v-model="info.control_type"
                  />
                  注意制御
                </label>
                <label style="width:150px;">
                  <input
                    type="radio"
                    class="radio"
                    id="limit_control"
                    value="1"
                    v-model="info.control_type"
                  />
                  限界制御
                </label>
              </div>
            </li>

            <li>
              <div>
                <label>
                  <input
                    type="checkbox"
                    id="control_reserve"
                    v-model="info.control_reserve"
                    name="control_reserve"
                  />
                  &nbsp;空調機の制御を終日行う
                </label>
              </div>
            </li>

            <li>
              <div>
                <input
                  type="password"
                  id="password"
                  v-model="info.password"
                  v-validate="{
                    required: true,regex: /^[0-9a-zA-Z!&quot;#$%&amp;@'|<>(){}\[\]*+,./_\-~=\;\:\?\^]{6,16}$/,min: 6,max: 16
                  }"
                  placeholder="パスワード"
                  name="password"
                />
              </div>
            </li>
          </ul>

          <div class="submit_area">
            <input
              type="submit"
              class="submit"
              value="設  定"
              @click="onSetting"
            />
            <input
              type="button"
              class="cancel"
              value="キャンセル"
              @click="onClose"
            />
          </div>
        </div>
      </div>

      <!------------------------------------------------------------------
      <-- 空調自動制御(手動) -解除-
      <------------------------------------------------------------------>
      <div class="manual_control_container" v-else>
        <h2>空調自動制御 -解除-</h2>
        <div class="form">
          <label style="color:red;">空調機の制御予約を取り消します。</label>
          <ul>
            <li>
              <div>
                <input
                  type="password"
                  id="password"
                  v-model="info.password"
                  v-validate="{
                    required: true,regex: /^[0-9a-zA-Z!&quot;#$%&amp;@'|<>(){}\[\]*+,./_\-~=\;\:\?\^]{6,16}$/,min: 6,max: 16
                  }"
                  placeholder="パスワード"
                  name="password"
                />
              </div>
            </li>
          </ul>

          <div class="submit_area">
            <input
              type="submit"
              class="submit"
              value="解  除"
              @click="onCancel"
            />
            <input
              type="button"
              class="cancel"
              value="キャンセル"
              @click="onClose"
            />
          </div>
        </div>
      </div>
      <!----------------------------------------------------------------->

    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "manual_control_dialog",
  props: ["account", "loginID", "reserved"],

  data: function() {
    return {
      info: {
        control_type: 2,
        control_reserve: false,
        password: null
      }
    };
  },

  methods: {
    onClose: function() {
      this.$emit("close");
    },

    onSetting: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            account: this.account,
            control_type: this.info.control_type,
            control_reserve: this.info.control_reserve,
            password: this.info.password
          };
          this.$axios
            .put(`/srv/api/monthly_threshold/configuration/${this.loginID}`, param, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              const data = response.data;
              if (data.status !== undefined) {
                if (data.status === "success") {
                  this.$parent.info.commonSetting.manual_control_reserved = true;
                  this.$emit("close");
                } else {
                  console.log("error");
                  alert("設定できませんでした");
                }
              } else {
                console.log("error");
                alert("設定できませんでした");
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          alert("正しいパスワードを入力してください");
        }
      });
    },

    onCancel: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          let param = {
            account: this.account,
            password: this.info.password
          };
          this.$axios
            .put(`/srv/api/monthly_threshold/cancellation/${this.loginID}`, param, {
              withCredentials: true
            })
            .then(response => {
              console.log(response.data);
              const data = response.data;
              if (data.status !== undefined) {
                if (data.status === "success") {
                  this.$parent.info.commonSetting.manual_control_reserved = false;
                  this.$emit("close");
                } else {
                  console.log("error");
                  alert("解除できませんでした");
                }
              } else {
                console.log("error");
                alert("解除できませんでした");
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          alert("正しいパスワードを入力してください");
        }
      });
    }
  },

};
</script>
